module.exports = __webpack_public_path__ + "static/media/press_content_05.a8f6634d.png";